import { mapInstrumentSearchResults } from "../Watchlist/instrumentSearchData";

export const INSTRUMENT_SEARCH_DEBOUNCE_MS = 300;

export function tokenizeInstrumentSearchInput(input) {
  return String(input || "")
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
}

export function buildInitialSearchInputFromSymbol(symbol) {
  const raw = String(symbol || "").trim();
  if (!raw) return "";

  const tokens = raw.toLowerCase().match(/[a-z]+|\d+/g);
  if (!tokens?.length) return raw.toLowerCase();

  return tokens.join(" ");
}

export function extractInstrumentSymbols(response) {
  return mapInstrumentSearchResults(response)
    .map((item) => item.symbol)
    .filter(Boolean);
}

export function mergeInstrumentSymbolOptions(options, selectedSymbol) {
  const merged = new Set(options || []);
  if (selectedSymbol) {
    merged.add(selectedSymbol);
  }
  return Array.from(merged);
}
